import {
  CircularProgress,
  Container,
  Grid,
  GridList,
  GridListTile,
  GridListTileBar,
  IconButton,
  Paper
} from '@material-ui/core'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'

import { FaCloudUploadAlt, FaTrashAlt } from 'react-icons/fa'

import Context from '../../context'
import { getDashData } from '../../services/ReportsApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'
import useStyles from './styles'

import DashboardCalendar from '../../components/Calendar'
import { createClientImage } from '../../services/ClubeApi'
import DeleteDialog from './Components/DeleteDialog'
import ImageDialog from './Components/ImageDialog'

const { REACT_APP_IMAGES_URL } = process.env

function ImagesManagerPage() {
  const classes = useStyles()

  const { user, setUser, rangeDate, setRangeDate } = useContext(Context)
  const [usersImagesList, setUsersImagesList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [itemLoading, setItemLoading] = useState({ id: 0, loading: true })
  const [openDialog, setOpenDialog] = useState(false)
  const [imageToDelete, setImageToDelete] = useState({})
  const [imageData, setImageData] = useState({})
  const [openImageDialog, setOpenImageDialog] = useState(false)

  const updateData = () => {
    setIsLoading(true)

    getDashData(
      undefined,
      moment(rangeDate[0]).format('YYYY-MM-DD').toString(),
      moment(rangeDate[1]).format('YYYY-MM-DD').toString()
    ).then(r => {
      const { usersImage } = r

      setUsersImagesList(
        usersImage.map(item => {
          const resItem = { ...item, cols: 1, rows: 1 }
          const img = new Image()

          img.src = `${REACT_APP_IMAGES_URL}${item.image}`
          img.onload = () => {
            const calc = img.width / img.height
            if (calc < 1) {
              resItem.rows = 2
            }
            if (calc > 1) {
              resItem.cols = 2
            }
          }
          return resItem
        })
      )

      setIsLoading(false)
    })
  }

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }

    updateData()
  }, [])

  useEffect(() => {
    updateData()
  }, [rangeDate])

  const checkIsLoading = id => {
    return id === itemLoading.id && itemLoading.loading
  }

  const changeSituation = (item, situation) => {
    setItemLoading({ id: item.id, loading: true })
    setOpenDialog(false)

    const body = { id: item.id, situation }

    createClientImage(body).then(r => {
      if (r) {
        setItemLoading({ id: 0, loading: false })
        if (situation === 2) {
          setUsersImagesList(list => {
            return list.filter(listItem => listItem.id !== item.id)
          })
        } else {
          setUsersImagesList(list => {
            return list.map(listItem => {
              if (item.id === listItem.id) {
                return { ...listItem, situation: 1 }
              }
              return listItem
            })
          })
        }
      }
    })
  }

  const handleDelete = item => {
    setImageToDelete(item)
    setOpenDialog(true)
  }

  return (
    <Container maxWidth="xl" style={{ paddingLeft: '50px', paddingRight: '50px' }}>
      <Grid container spacing={2}>
        <Context.Provider
          value={{
            user,
            setUser,
            rangeDate,
            setRangeDate,
            openDialog,
            setOpenDialog,
            imageToDelete,
            openImageDialog,
            setOpenImageDialog,
            imageData
          }}
        >
          <Grid item xs={12} sm={12}>
            <Grid container style={{ marginBottom: '25px', marginTop: '15px' }}>
              <Grid item xs={12} style={{ paddingLeft: '10px' }}>
                <h1>Imagens</h1>
              </Grid>

              {isLoading ? (
                <Grid item xs={8}>
                  <Grid className={classes.progressArea}>
                    <CircularProgress />
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={8} style={{ padding: '15px' }}>
                  {usersImagesList.length > 0 ? (
                    <GridList cellHeight={250} cols={3}>
                      {usersImagesList.map(tile => (
                        <GridListTile
                          key={tile.id}
                          // cols={tile.cols}
                          // rows={tile.rows}
                        >
                          <img
                            src={`${REACT_APP_IMAGES_URL}${tile.image}`}
                            alt={tile.image}
                            className="item-click"
                            onClick={() => {
                              setImageData({
                                url: `${REACT_APP_IMAGES_URL}${tile.image}`,
                                local: tile.PartnerUnit ? tile.PartnerUnit.fantasyName : ''
                              })
                              setOpenImageDialog(true)
                            }}
                          />
                          <GridListTileBar
                            title={tile.title}
                            titlePosition="top"
                            subtitle={
                              <span>{tile.PartnerUnit ? tile.PartnerUnit.fantasyName : ''}</span>
                            }
                            actionIcon={
                              checkIsLoading(tile.id) ? (
                                <Grid className={classes.progressArea}>
                                  <CircularProgress color="secondary" />
                                </Grid>
                              ) : (
                                <>
                                  {tile.situation === 3 && (
                                    <IconButton
                                      aria-label={`star ${tile.title}`}
                                      className={classes.publishIcon}
                                      onClick={() => {
                                        changeSituation(tile, 1)
                                      }}
                                    >
                                      <FaCloudUploadAlt />
                                    </IconButton>
                                  )}
                                  <IconButton
                                    aria-label={`star ${tile.title}`}
                                    className={classes.trashIcon}
                                    onClick={() => {
                                      handleDelete(tile)
                                    }}
                                  >
                                    <FaTrashAlt />
                                  </IconButton>
                                </>
                              )
                            }
                            actionPosition="right"
                            className={classes.titleBar}
                          />
                        </GridListTile>
                      ))}
                    </GridList>
                  ) : (
                    <Paper elevation={3} style={{ height: '80px', padding: '10px' }}>
                      <h5>
                        Não foram encontrado dados entre{' '}
                        {moment(rangeDate[0]).format('DD/MM/YYYY').toString()} a{' '}
                        {moment(rangeDate[1]).format('DD/MM/YYYY').toString()}.
                      </h5>
                    </Paper>
                  )}
                </Grid>
              )}

              <Grid item xs={4} style={{ maxHeight: '400px', marginTop: '15px' }}>
                <DashboardCalendar />
              </Grid>

              <Grid item xs={12} style={{ marginTop: '20px' }} />
            </Grid>
          </Grid>
          <DeleteDialog changeSituation={changeSituation} />
          <ImageDialog />
        </Context.Provider>
      </Grid>
    </Container>
  )
}

export default ImagesManagerPage
